<script>
	import { onMount, onDestroy } from "svelte";
	import { navigate } from "svelte-routing";
	import { Button, Col, Row } from "sveltestrap";
	import queryString from "query-string";
	import client from "../../../services/client";
	import {
		sizeSelect,
		totalPages,
		loading,
		blackoutCarData,
		createBlackoutData,
		initPage,
		errorMessage,
	} from "../../../store/store";
	import BlackoutManagementTable from "./BlackoutManagementTable.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import FilterForm from "../../../components/FilterForm/FilterForm.svelte";
	import SizeSelect from "../../../components/SizeSelect/SizeSelect.svelte";
	import { extractErrorMessage } from "../../../utils/misc";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";

	let data = [];

	//Start Logic for filter feature
	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});
	$: queryParams = `?Page=1&size=${$sizeSelect}`;
	let searchParams = window.location.search.toString();
	let queryPage = searchParams.includes("page");
	let queryPlateNumber = searchParams.includes("plateNumber");
	let queryStartDateRange = searchParams.includes("startDateRange");
	let queryEndDateRange = searchParams.includes("endDateRange");

	$: if (queryPage) {
		queryParams = `?page=${params.page}&size=${$sizeSelect}`;
	}
	$: if (queryPlateNumber) {
		queryParams = queryParams.concat(
			`&CarPlateNumber=${params.plateNumber}`
		);
	}
	$: if (queryStartDateRange) {
		queryParams = queryParams.concat(
			`&BlackoutStartTime=${params.startDateRange}`
		);
	}
	$: if (queryEndDateRange) {
		queryParams = queryParams.concat(
			`&BlackoutEndTime=${params.endDateRange}`
		);
	}
	//End Logic for filter feature

	//FETCH Blackout vehicle LIST
	onMount(async () => {
		try {
			loading.set(true);
			const res = await client(`/v1/blackouts/filter${queryParams}`, {
				method: "GET",
				version: "Vehicle",
			});
			data = res.data.dataList;
			data.totalCount = res.data.totalCount;
			totalPages.set(res.data.totalPage);
			if (res.data.dataList) {
				loading.set(false);
			}
		} catch (err) {
			loading.set(false);
			console.log(err.response);
			extractErrorMessage(err);
		}
	});

	const handleInactive = async (id, status) => {
		loading.set(true);
		try {
			if (status == true) {
				status = false;
			} else {
				status = true;
			}
			const res = await client("/v1/blackouts/status", {
				method: "PUT",
				version: "Vehicle",
				data: {
					id: id,
					status: status,
				},
			});
			if (res.status === 200) {
				trigerSelectGroup();
			}
		} catch (error) {
			console.log(error);
			loading.set(false);
			extractErrorMessage(error);
		}
	};

	onDestroy(() => {
		initPage.set(1);
		sizeSelect.set("20");
	});
	const trigerSelectGroup = async () => {
		try {
			loading.set(true);
			const res = await client(`/v1/blackouts/filter${queryParams}`, {
				method: "GET",
				version: "Vehicle",
			});
			if (res.data.dataList) {
				loading.set(false);
			}
			data = res.data.dataList;
			totalPages.set(res.data.totalPage);

			data.totalCount = res.data.totalCount;
		} catch (err) {
			console.log(err);
			loading.set(false);
			extractErrorMessage(err);
		}
	};

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={err} />
			<Row className="align-items-center mb-3">
			<Col className="row d-flex align-items-start mx-0">
				<PageHeader title="Blackout Management" />
			</Col>
			<Col xs="auto" class="d-flex justify-content-end align-items-center">
					<div class="mx-2 d-flex flex-column align-items-center" style="width: 200px;">
						<Button
							class="themeButton primary px-4 w-100"
							on:click={() => {
								blackoutCarData.set("");
								createBlackoutData.set("");
								navigate("/blackout-management/create");
							}}>Create</Button
						>
						<p>
							<a
								href="/assets/csv/blackout_Template.csv"
								target="_blank"
								download="blackout_template.csv"
								rel="noreferrer"
								class="link link-text"
							>
								Download CSV Template
							</a>
						</p>
						
					</div>
				</Col>
				</Row>
			<div class="d-flex flex-row justify-content-between">
				<Col xs={6}>
					<FilterForm plateNumber startDateRange endDateRange />
				</Col>
				<div class="align-self-end">
							<SizeSelect trigerSelect={trigerSelectGroup} />
				</div>
			</div>
		</div>
	</Col>
	<Col class="my-2">
		<BlackoutManagementTable {data} {handleInactive} />
	</Col>
</Row>